import React, { useEffect, useState } from "react";
import { imgArr } from "../../assets/images";

const features = [
  {
    title: "Find Your Friends",
    desc: `Follow your friends and see which classes they’re taking, so you can plan to join, or invite them to something new`,
  },
  {
    title: "Real-Time Class Feed",
    desc: `Scroll through a personalized feed of classes your friends are posting, saving, and attending`,
  },
  {
    title: "Social Calendar Sync",
    desc: `Add classes to your Circuit calendar and see what your friends have planned, making coordination simple and consistent`,
  },
  {
    title: "Save and Share Studios",
    desc: `Bookmark your favorite classes, save sessions to try later, and share studio recs with your group, all in one tap`,
  },
  {
    title: "Seamless Booking Flow",
    desc: `Book your class directly on our platform. Link your email to use your studio’s class credits or memberships`,
  },
  {
    title: "Full-Circle Fitness",
    desc: `After class post about it, tag your friends, and inspire your circle to book their next one, too`,
  },
];

const sliderImages = [imgArr.FeedCalendar, imgArr.Feeddots];

const FeaturesComponent = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === sliderImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 6000); // Change image every 6s
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="features wapper" id="#feature">
      <div className="features-title">
        <h2 className="main-title">How Circuit Works</h2>
      </div>
      <div className="information">
        <div
          className="feature-details"
          style={{ paddingRight: "10px" }}
          data-aos="slide-right"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <div className="featureitem">
            {features?.slice(0, 3)?.map((item1, index) => (
              <div className="feature-info" key={index}>
                <div className="feature-title">
                  <p>{item1?.title}</p>
                </div>
                <div
                  className="feature-description"
                  dangerouslySetInnerHTML={{ __html: item1?.desc }}
                />
              </div>
            ))}
          </div>
        </div>
        <div
          className="feature-image col-md-4 text-center position-relative"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <img
            src={sliderImages[currentImageIndex]}
            alt="Feature Slider"
            className="img-fluid rounded shadow"
            style={{
              height: "500px",
              width: "100%",
              objectFit: "contain",
              transition: "opacity 0.5s ease-in-out",
            }}
          />
        </div>
        <div
          className="feature-details"
          style={{ paddingLeft: "10px" }}
          data-aos="slide-left"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <div className="featureitem">
            {features?.slice(3, 6)?.map((item1, index) => (
              <div className="feature-info" key={index}>
                <div className="feature-title">
                  <p>{item1?.title}</p>
                </div>
                <div
                  className="feature-description"
                  dangerouslySetInnerHTML={{ __html: item1?.desc }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesComponent;
